const notes = {
  features: [],
  fixes: ['Show names automatically in print course plan page', 'Security fix'],
};
export default notes;
